import React from 'react';
import MetaDataMarkup from 'components/MetaDataMarkup';
import { getInitialPropsForFullCMSPage } from 'helpers/fullCMSPage';
import { gmConfig } from 'helpers/config';
import FullCmsPage from 'views/FullCMSPage';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

const EventProtectionPage = ({ pageContent }) => {
  const { body, metaDescription: description } = pageContent;

  const title = `AI Usage Policy`;
  const openGraphProps = {
    description,
    title,
    type: 'website',
    url: `https://${gmConfig.domains.www}/ai-usage-policy`,
  };

  return (
    <>
      <MetaDataMarkup title={title} description={description} openGraphProps={openGraphProps} />
      <FullCmsPage title={title} content={body} />
    </>
  );
};

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, async (ctx) => {
      return await getInitialPropsForFullCMSPage('ai-usage-policy');
    })
);

export default EventProtectionPage;
